import React, { FC } from 'react';
import { UnscheduledVisitOrderNotification } from './UnscheduledVisitOrderNotification';
import { UnscheduledVisitOrderPopover } from './UnscheduledVisitOrderPopover';
import { QCVisitExtendedWithContextDataAndDates } from '../../hooks/useMergedVisits.hook';
import { QCPatientVisitDates } from '@dynamika-shared/types/visits';
import {
  moveVisitLeft,
  moveVisitRight,
} from 'src/pages/QC/QCTask/components/visitOrderHandler';
import { QCVisit } from 'src/pages/QC/QCVisit/QCVisit';

type VisitTabContentProps = {
  visit: QCVisitExtendedWithContextDataAndDates;
  isCurrentVisit: boolean;
  isReorderingMode: boolean;
  currentVisitId: string | null;
  wrapperRef: React.RefObject<HTMLDivElement>;
  isQueueChanged: boolean;
  orderedVisits: QCVisitExtendedWithContextDataAndDates[];
  fetchQCPatientVisitsDatesSuccess: (visits: QCPatientVisitDates[]) => void;
  handleOpenPopover: (visitId: string) => void;
  closePopover: () => void;
  setIsQueueChanged: (val: boolean) => void;
  setConfirmModal: (val: { isOpen: boolean; visitId: string | null }) => void;
  setUnlockModal: (val: { isOpen: boolean; visitId: string | null }) => void;
};

export const VisitTabContent: FC<VisitTabContentProps> = ({
  visit,
  isCurrentVisit,
  isReorderingMode,
  currentVisitId,
  wrapperRef,
  isQueueChanged,
  orderedVisits,
  fetchQCPatientVisitsDatesSuccess,
  handleOpenPopover,
  closePopover,
  setIsQueueChanged,
  setConfirmModal,
  setUnlockModal,
}) => {
  const currentVisit = orderedVisits.find(v => v.id === currentVisitId);
  const currentVisitOrder = currentVisit?.customOrder;
  return (
    <>
      {(!visit.visitOrderLocked || visit.canUnlockVisitOrder) && (
        <UnscheduledVisitOrderNotification
          status={visit.visitOrderLocked ? 'success' : 'warning'}
          onClick={e => {
            e.stopPropagation();
            if (visit.visitOrderLocked) {
              setUnlockModal({ isOpen: true, visitId: visit.id });
            } else {
              handleOpenPopover(visit.id);
            }
          }}
        />
      )}
      <UnscheduledVisitOrderPopover
        wrapperRef={wrapperRef}
        open={isReorderingMode && isCurrentVisit}
        okButtonProps={{ disabled: !isQueueChanged }}
        onClose={closePopover}
        controlsProps={{
          isRightDisabled: currentVisitOrder === orderedVisits.length,
          isLeftDisabled: currentVisitOrder === 1,
        }}
        onMoveLeft={() => {
          moveVisitLeft(
            currentVisitId,
            orderedVisits,
            fetchQCPatientVisitsDatesSuccess,
            setIsQueueChanged
          );
        }}
        onMoveRight={() => {
          moveVisitRight(
            currentVisitId,
            orderedVisits,
            fetchQCPatientVisitsDatesSuccess,
            setIsQueueChanged
          );
        }}
        onConfirmPosition={() => {
          setConfirmModal({ isOpen: true, visitId: currentVisitId });
          setIsQueueChanged(false);
        }}
      />
      <QCVisit visit={visit} />
    </>
  );
};
